<template>
    <v-dialog v-model="dialog" max-width="500px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="warning"
          dark
          v-bind="attrs"
          v-on="on"
          small
          class="mx-2"
          >Projects
        </v-btn>
      </template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            Project Name
          </th>
          <th class="text-left">
            Edit
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in client.projects"
          :key="item.id"
        >
          <td><router-link :to="'/home?filtername='+item.title">{{ item.title }}</router-link></td>
          <td><ProjectEditModal :projectid="item.id" class="mx-2"/></td> 
        </tr>
      </tbody>
    </template>
  </v-simple-table>
    </v-dialog>
</template>

<script>
import ProjectEditModal from './ProjectEditModal.vue'; 
  export default {
   components: {
    ProjectEditModal,
    },
    props : {
        client : Object
    },
  }
</script>